import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/ProductCard.css';

const ProductCard = ({ product }) => {
  const mainImage = product.images?.[0] || 'https://via.placeholder.com/300x200?text=Product';

  return (
    <Link to={`/products/${product.id}`} className="product-card">
      <div className="product-image-wrapper">
        <img
          src={mainImage}
          alt={product.name}
          className="product-image"
          loading="lazy"
        />
        {product.isFeatured && (
          <span className="product-badge">Featured</span>
        )}
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-description">{product.shortDescription}</p>
        <div className="product-footer">
          <span className="product-price">{product.price}</span>
          <span className="product-cta">{product.ctaText || 'View Details'}</span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
